export function compareFinishes(finish1: string, finish2: string): number {
  // if (itemA.isRefined && !itemB.isRefined) return -1;
  // if (!itemA.isRefined && itemB.isRefined) return 1;

  if (finish1 !== finish2) {
    if (finish1 === 'Polished Chrome') return -1;
    if (finish2 === 'Polished Chrome') return 1;
    if (finish1 < finish2) return -1;
    if (finish1 > finish2) return 1;
  }

  return 0;
}

export function compareShowerTrimModifierId(
  showerTrimModifierId1: string | null,
  showerTrimModifierId2: string | null
): number {
  if (showerTrimModifierId1 !== showerTrimModifierId2) {
    if (showerTrimModifierId1 === null) return -1;
    if (showerTrimModifierId2 === null) return 1;
    if (showerTrimModifierId1 < showerTrimModifierId2) return -1;
    if (showerTrimModifierId1 > showerTrimModifierId2) return 1;
  }

  return 0;
}
